
const toIdentifier = (value) => String(value || "").trim();

export function getEntityId(entity) {
  return toIdentifier(entity?.uid || entity?.id);
}

export function normalizeManuscriptIds(value) {
  if (!Array.isArray(value)) return [];

  return Array.from(
    new Set(value.map(toIdentifier).filter(Boolean)),
  );
}

export function getAssignedManuscripts(master, manuscripts = []) {
  const assignedIds = new Set(
    normalizeManuscriptIds(master?.manuscriptIds),
  );

  if (assignedIds.size === 0) return [];

  return manuscripts.filter((manuscript) =>
    assignedIds.has(getEntityId(manuscript)),
  );
}

export function getMastersWithManuscripts(masters = [], manuscripts = []) {
  const availableIds = new Set(
    manuscripts.map(getEntityId).filter(Boolean),
  );

  return masters
    .map((master) => ({
      ...master,
      manuscriptIds: normalizeManuscriptIds(master?.manuscriptIds).filter(
        (id) => availableIds.has(id),
      ),
    }))
    .filter((master) => master.manuscriptIds.length > 0)
    .sort((a, b) =>
      String(a?.name || "").localeCompare(String(b?.name || ""), "uk", {
        sensitivity: "base",
      }),
    );
}

export function filterMastersBySearch(masters = [], search = "") {
  const query = String(search).trim().toLocaleLowerCase("uk-UA");

  if (!query) return masters;

  return masters.filter((master) =>
    String(master?.name || "")
      .toLocaleLowerCase("uk-UA")
      .includes(query),
  );
}

export function getActiveMaster(masters = [], selectedMasterId = "") {
  const normalizedSelectedId = toIdentifier(selectedMasterId);

  return (
    masters.find(
      (master) => getEntityId(master) === normalizedSelectedId,
    ) ||
    masters[0] ||
    null
  );
}
